import React from 'react';
import { Field, CccisdSelect, CccisdInput } from 'cccisd-formik';
import { reportTemplateBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    chapterTitle: 'Stress Thermometer',
};

const Component = () => {
    const chapters = [
        { value: '', label: '-- Choose Chapter Report --' },
        { value: 2, label: 'Chapter 2' },
        { value: 4, label: 'Chapter 4' },
    ];

    return (
        <div>
            <Field name="chapter" component={CccisdSelect} label="Chapter Report" options={chapters} />
            <Field name="chapterTitle" component={CccisdInput} label="Chapter Title" />
        </div>
    );
};

export default reportTemplateBuilder({})(Component);
